import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { QaReportService } from '../services/qa-report.service';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { ReportService } from 'src/app/repository/service/report.service';

@Component({
  selector: 'app-qa-report',
  templateUrl: './qa-report.component.html',
  styleUrls: ['./qa-report.component.scss']
})
export class QaReportComponent implements OnInit, OnDestroy {

  // public isFilter:boolean = false;
  startDate
  endDate
  startMonth
  endMonth
  

  public dateFilter = {"startDate":'',"endDate":'',"selectedYear":''};
  // public dateFilter = {"startDate":'',"endDate":'',"selectedYear":''};
  public showTree = false;
  public filterOption:any = [];
  public treeFilterOption:any = [];
  constructor(public reportService:ReportService,
    public qaService:QaReportService,
    public notifier:NotifierService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef) {
    this.qaService.initSideDrawerEvent
        .subscribe(()=> {
          this.selectSheet();
        })
   
   }
  
  ngOnDestroy(): void {
    this.qaService.resetReportGrid();
    this.qaService.selectedSheet = {"name":""};
    this.qaService.selectedTab = {};
  }

  ngOnInit(): void {
    this.qaService.isOpen = true;
    if (this.qaService.qaReportConfig && this.qaService.qaReportConfig.length > 0) {
      this.selectSheet()
    }
    setTimeout(() => {
      this.showTree = true;
    }, 1000);
  }
 
  selectSheet(){
    let selectedSheetKey = this.router.url.split('/')[2] ? this.router.url.split('/')[2] : "";
    if (selectedSheetKey && selectedSheetKey !='') {
      this.qaService.selectedSheet = this.qaService.qaReportConfig.find(item => { return item.sheet_key == selectedSheetKey});
      if (this.qaService.selectedSheet && this.qaService.selectedSheet['tabs'] && this.qaService.selectedSheet['tabs'][0]) {
        this.selectTab(this.qaService.selectedSheet['tabs'][0]);
      }
    }
  }
  selectTab(tab){
    // this.qaService.qaReportGridJson = {"headers":{},"data": {}};
    this.qaService.appliedFilter = {};
    this.qaService.isLoadingGridData = true;
    this.qaService.selectedTab = tab;
    this.qaService.copyappliedFilter = {};
    
    // this.qaService.gridFilters = tab['filters'] ? JSON.parse(JSON.stringify(tab['filters'])) : {};
    this.qaService.gridTabFilters = {};
    this.qaService.reportFiltersCopy = [];
    this.qaService.setTabFilters();
    this.setDefaultYears(this.qaService.selectedTab['default_year_range']);

    // this.setDefaultDates();
    // this.setDefaultDateRange();
    this.qaService.isGridFilter = false;
    this.qaService.gridTreeFilterCopy = {};
    let body = this.qaService.selectedTab['req_body']
    body["filters"] = this.qaService.appliedFilter ?this.qaService.appliedFilter : {};
    if (this.qaService.appliedFilter && this.qaService.appliedFilter['frequency'] && this.qaService.appliedFilter['frequency'].length) {
      let frequencyCheck = JSON.stringify(body)
      const updatedDataString = frequencyCheck.replace(/{{frequency}}/g, this.qaService.appliedFilter['frequency'][0]);
      body = JSON.parse(updatedDataString);
    }
    this.qaService.getReportGrid(body);
  }

  editSheet(){}
  copySheet(){}
  deleteSheet(){}

  getFilterLabel(label){
    label = label+'';
    let tempLabel = label.split("#");
    let newLabel = tempLabel[0];
    if (tempLabel[1]) {
      newLabel = newLabel + ' ('+ tempLabel[1]+')'
    }

    return newLabel
  }

  setDefaultDateRange(){
    if (this.qaService.selectedTab && this.qaService.selectedTab['filters'] && this.qaService.selectedTab['filters']['Date'] && this.qaService.selectedTab['filters']['Date'][0] && this.qaService.selectedTab['filters']['Date'][0]['default_year_range']) {
      let start = new Date();
      let end = new Date();
      this.qaService.selectedTab['filters']['Date'][0]['default_year_range']
      this.startDate = new Date(start.getFullYear() - this.qaService.selectedTab['filters']['Date'][0]['default_year_range'], start.getMonth(),1);
      this.endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
      this.onDateRangeChange('date');
    }
  }
  onDateRangeChange(key){
    if(!this.qaService.appliedFilter[key]){
      this.qaService.appliedFilter[key] = [];
    }
    let startMonth =  this.startDate.getMonth() + 1
    let endMonth =  this.endDate.getMonth() + 1
    let start_date = '';
    let end_date = '';
    if (this.startDate) {
      start_date = this.startDate.getFullYear()+'-'+startMonth+'-01 00:00:00';
    }
    if (this.endDate) {
      end_date = this.endDate.getFullYear()+'-'+endMonth+'-'+this.endDate.getDate()+' 23:59:59';
    }
    this.qaService.appliedFilter[key][0] = start_date;
    this.qaService.appliedFilter[key][1] = end_date;
  }

  // onSearchStrChange(searchStr, key ){
  //   let list = Object.values(this.qaService.gridFiltersCopy[key]);
  //   let filterKey = list[0]['key'];
  //   let search = searchStr.toLowerCase();
  //   if (search.length>0) {
  //     let searchList = list.filter(option => option['label'].toLowerCase().includes(search) || option['label'].toLowerCase().includes('all'));
  //     let selectedList = this.qaService.appliedFilter[filterKey] ? list.filter(item =>{ return this.qaService.appliedFilter[filterKey].includes(item['label'])}) : [];
  //     list = [...searchList,...selectedList]
  //     this.qaService.gridFilters[key] = {};
  //     list.forEach((element, index) => {
  //       this.qaService.gridFilters[key][index] = element;
  //     })
  //   }else{
  //     this.qaService.gridFilters[key] = this.qaService.gridFiltersCopy[key];
  //   }
  // }
  // getOptions(key){  
  //   return this.qaService.gridFilters[key];  
  // }
  

  // onGridFilterChange(filterKey:string){
  //   this.qaService.gridTreeFilterCopy = JSON.parse(JSON.stringify(this.qaService.gridTreeFilters));
  //   this.qaService.appliedFilter[this.qaService.gridTreeFilters[filterKey]['key']] = this.qaService.gridTreeFilters[filterKey]['selectedOptions'].map(item =>{return item['value']});
  // }

  onGridFilterChange(filter:any){
    this.qaService.appliedFilter[filter['key']] = filter['selectedOptions'].map(item =>{return item['value']});
    // console.log("this.qaService.reportFilters",this.qaService.reportFilters);
    // console.log("this.qaService.appliedFilter",this.qaService.appliedFilter)
  }

  getFilterName(filterKey){
    return "Select "+filterKey;
  }

  onRadioFilterChange(filter:any,value){
    filter['selectedOption'] = value;
    if (filter['key'] == 'year') {
      if (filter['fkey'] == 'from') {
        this.qaService.appliedFilter["date"][0] = value+"-01-01 00:00:00";
        if (this.qaService.defaultGraphFrequency == "Quarter" || this.qaService.defaultGraphFrequency == "Month") {
          let selectedOption = Object.values(filter['value']).find(item => { return item['value'] == value});
          if (selectedOption && selectedOption["end"] && selectedOption["end"] !="") {
            this.qaService.appliedFilter["date"][1] = value+"-"+selectedOption["end"];
          }else{
            this.qaService.appliedFilter["date"][1] = value+"-12-31 23:59:59";
          }
          // this.qaService.appliedFilter["date"][1] = value+"-03-31 23:59:59";
        }
      }else if (filter['fkey'] == 'to') {
        this.qaService.appliedFilter["date"][1] = value+"-12-31 23:59:59";
      }
    }else if(filter['key'] == 'quarter'){
      let selectedOption = Object.values(filter['value']).find(item => { return item['value'] == value});
      this.qaService.appliedFilter["date"][0] = this.qaService.defaultReportDate.startDate+"-"+selectedOption["start"];
      this.qaService.appliedFilter["date"][1] = this.qaService.defaultReportDate.startDate+"-"+selectedOption["end"];
    }else if(filter['key'] == 'month'){
      let selectedOption = Object.values(filter['value']).find(item => { return item['value'] == value});
      this.qaService.appliedFilter["date"][0] = this.qaService.defaultReportDate.startDate+"-"+selectedOption["start"];
      this.qaService.appliedFilter["date"][1] = this.qaService.defaultReportDate.startDate+"-"+selectedOption["end"];
    }else{
      this.qaService.appliedFilter[filter['key']] = [value];
    }
    if (filter['key'] == 'frequency') {
      let year_filters = {};
      let selectedFreq = {};
      selectedFreq = Object.values(this.qaService.gridTabFilters["frequency"]).find(item => { return item['value'] == filter['selectedOption']});
      this.qaService.defaultGraphFrequency = selectedFreq['value'];
      this.setDefaultYears(selectedFreq['default_year_range']);
      year_filters = selectedFreq['year_filters'];
      let frequencyChecks = ["from","to","quarter","month"];
      this.qaService.reportFilters.forEach(element => {
        if (frequencyChecks.includes(element['fkey'])) {
          if (Object.keys(year_filters).includes(element['fkey'])) {
            element['show'] = true;
          }else{
            element['show'] = false;
          }
        }
        if (element['key'] == 'year') {
          // if(year_filters && year_filters[element['fkey']] && year_filters[element['fkey']] == 'year'){
          //   element['show'] = true;
          // }else{
          //   element['show'] = false;
          // }
          if (element['fkey'] == 'from') {
            element['selectedOption'] = this.qaService.defaultReportDate.startDate;
          }else if (element['fkey'] == 'to') { 
            element['selectedOption'] = this.qaService.defaultReportDate.endDate;
          }
        }
      });

    }
    // console.log("this.qaService.reportFilters",this.qaService.reportFilters)
  }

  frequencyFilter(val){
    this.qaService.defaultGraphFrequency = val;
    console.log('this.qaService.defaultGraphFrequency',this.qaService.defaultGraphFrequency)
    this.qaService.appliedFilter['frequency'] = [val];
  }

  onDatepickerClosed() {
    // console.log('Datepicker closed');
  }
  setDefaultYears(year_range){
    let yearFilter = Object.values(this.qaService.qaDashboardConfig['filters']["year"]);
    let default_year_range = year_range ? year_range : 0;
    if (yearFilter && yearFilter.length) {
      // let startYear = this.getMaxValue(yearFilter)- this.qaService.selectedTab['default_year_range'];
      let startYear = this.getMaxValue(yearFilter) - default_year_range;
      
      let endYear = this.getMaxValue(yearFilter);
      let minYear = this.getMinValue(yearFilter);
      startYear = startYear < minYear ? minYear : startYear;
      this.qaService.defaultReportDate.startDate = startYear;
      this.qaService.defaultReportDate.endDate = endYear;
      this.dateFilter.startDate = startYear +'-01-01 00:00:00';
      this.dateFilter.endDate = endYear+'-12-31 23:59:59';
      this.qaService.appliedFilter["date"] = [];
      this.qaService.appliedFilter["date"].push(this.dateFilter.startDate)
      this.qaService.appliedFilter["date"].push(this.dateFilter.endDate)
    }
    
  }

  getMaxValue(data: any[]) {
    const values = data.map(item => item.value);
    return Math.max(...values); // Returns the maximum value
  }
  getMinValue(data: any[]) {
    const values = data.map(item => item.value);
    return Math.min(...values); // Returns the maximum value
  }

  setDefaultDates(){
    if (this.qaService.selectedTab && this.qaService.selectedTab['filters'] && this.qaService.selectedTab['filters']['Date'] && this.qaService.selectedTab['filters']['Date'][0] && this.qaService.selectedTab['filters']['Date'][0]['default_year_range']) {
      let start = new Date();
      let end = new Date();
      this.qaService.selectedTab['filters']['Date'][0]['default_year_range']
      this.startMonth = new Date(start.getFullYear() - this.qaService.selectedTab['filters']['Date'][0]['default_year_range'], start.getMonth(),1);
      this.endMonth = new Date(end.getFullYear(), end.getMonth(), end.getDate());

        this.dateFilter.startDate = this.startMonth.getFullYear()+'-01-01 00:00:00';
        this.dateFilter.endDate = this.endMonth.getFullYear()+'-12-'+this.endMonth.getDate()+' 23:59:59';
        this.qaService.appliedFilter["date"] = [];
        this.qaService.appliedFilter["date"][0] = this.dateFilter.startDate;
        this.qaService.appliedFilter["date"][1] = this.dateFilter.endDate;
    }
  }

  onMonthChange(event: any, datepicker: any, key) {
    const selectedDate = new Date(event);
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();  
    const actualMonth = month + 1;  
    if (key == 'startDate') {
      this.startMonth =  new Date() 
      this.startMonth.setFullYear(year, month , 1);
      this.dateFilter.startDate = year+'-'+actualMonth+'-01 00:00:00'
      this.qaService.appliedFilter["date"][0] = this.dateFilter.startDate;
    }else{
      const lastDateOfMonth = new Date(year, month + 1, 0);
      this.endMonth =  new Date() 
      this.endMonth.setFullYear(year, month +1 , 0);
      this.dateFilter.endDate = year+'-'+actualMonth+'-'+this.endMonth.getDate()+' 23:59:59'
      this.qaService.appliedFilter["date"][1] = this.dateFilter.endDate;
    }
    datepicker.close(); // Close the datepicker after selection
  }

   onYearChange(event: any, datepicker: any, key) {
    const selectedDate = new Date(event);
    const year = selectedDate.getFullYear();
    if (key == 'startDate') {
      this.startMonth =  new Date() 
      this.startMonth.setFullYear(year, 0 , 1);
      this.dateFilter.startDate = year+'-01-01 00:00:00'
      this.qaService.appliedFilter["date"][0] = this.dateFilter.startDate;
    }else if (key == 'endDate') {
      // const lastDateOfMonth = new Date(year, month + 1, 0);
      this.endMonth =  new Date() 
      this.endMonth.setFullYear(year, 12 , 0);
      // this.endMonth.setFullYear(year, month , lastDateOfMonth);
      this.dateFilter.endDate = year+'-12-'+this.endMonth.getDate()+' 23:59:59'
      this.qaService.appliedFilter["date"][1] = this.dateFilter.endDate;
    }
    datepicker.close(); // Close the datepicker after selection
  }

  navigateToDashboard(){
    this.router.navigate(['/qa-report/qa-dashboard']);
  }
}
